"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewContentCommand = void 0;
class ViewContentCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { viewType, value, contents } = this.input;
        const { gtag: googleAnalyst } = config;
        const contentName = viewType === 'ViewContent' ? 'view_item' : 'view_item_list';
        googleAnalyst('event', contentName, {
            currency: 'VND',
            value: value,
            items: contents?.map(content => ({
                item_id: content.id,
                item_name: content.content_data?.name ?? 'no-name',
                google_business_vertical: 'retail'
            })) ?? []
        });
        return Promise.resolve();
    }
}
exports.ViewContentCommand = ViewContentCommand;
